import { TimerMarkerIcon } from './TimerMarkerIcon';

/**
 * author: Colton Wiscombe
 * id 821CEDA0-CD59-45AF-BF1A-EE56399BC374
 * name timer-marker
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-marker.svg
 * tags
 * - Date / Time 
 * - Navigation 
 */
export const StopwatchLocationIcon = TimerMarkerIcon;
export default StopwatchLocationIcon